import {
  Fragment,
  useRef,
  useState,
} from 'react';
import { Link as RouterLink } from 'react-router-dom';
import moment from 'moment';
import {
  Avatar,
  Badge,
  Box,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Popover,
  SvgIcon,
  Tooltip,
  Typography,
  makeStyles,
} from '@material-ui/core';
import {
  BlurCircular as BlurCircularIcon,
  Error as ErrorIcon,
  NotificationsActive as NotificationsActiveIcon,
  NotificationsNone as NotificationsNoneIcon,
  NotificationImportant as NotificationImportantIcon,
} from '@material-ui/icons';
import { green, red } from '@material-ui/core/colors';

const typeIcons = {
  default: BlurCircularIcon,
  error: ErrorIcon,
  notification: NotificationImportantIcon,
};

const typeColors = {
  error: 'icon_error',
  notification: 'icon_notification',
};

const useStyles = makeStyles((theme) => ({
  popover: {
    width: 320,
  },
  icon_default: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
  },
  icon_notification: {
    backgroundColor: green[700],
    color: theme.palette.secondary.contrastText,
  },
  icon_error: {
    backgroundColor: red[700],
    color: theme.palette.secondary.contrastText,
  },
}));

function Notifications() {
  const classes = useStyles();
  const pendings = {
    total: 0,
  };

  const ref = useRef(null);
  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Tooltip title="Notificaciones">
        <IconButton color="inherit" ref={ref} onClick={handleOpen}>
          <Badge badgeContent={pendings.total} color="default">
            <SvgIcon
              children={pendings.total
                ? <NotificationsActiveIcon />
                : <NotificationsNoneIcon />
              }
            />
          </Badge>
        </IconButton>
      </Tooltip>
      <Popover
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        classes={{
          paper: classes.popover,
        }}
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
      >
        <Box p={2}>
          <Typography
            children="Notificaciones"
            color="textPrimary"
            variant="h5"
          />
        </Box>
        {pendings.total === 0 ? (
          <Box p={2}>
            <Typography
              children="Sin notificaciones"
              color="textPrimary"
              variant="h6"
            />
          </Box>
        ) : (
          <List className={classes.list} disablePadding>
            {pendings.rows.slice(0, 5).map(({ created_at, id, message }, index) => {
              const Icon = typeIcons[message?.alert_type || 'default'] || Fragment;

              return (
                <ListItem
                  className={classes.listItem}
                  component={RouterLink}
                  divider
                  key={index}
                  onClick={handleClose}
                  to={`/notifications/${message.type}/${message.token}`}
                >
                  <ListItemAvatar>
                    <Avatar className={classes[typeColors[message?.alert_type] || 'icon_default']}>
                      <SvgIcon fontSize="small">
                        <Icon />
                      </SvgIcon>
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={message?.name}
                    primaryTypographyProps={{
                      variant: 'subtitle2',
                      color: 'textPrimary',
                    }}
                    secondary={moment(created_at).format('YYYY-MM-DD HH:mm:ss')}
                  />
                </ListItem>
              );
            })}
          </List>
        )}
        <Box p={1} display="flex" justifyContent="center">
          <Button
            children="Ver más"
            component={RouterLink}
            onClick={handleClose}
            size="small"
            to="/notifications"
          />
        </Box>
      </Popover>
    </>
  );
}

export default Notifications;
